(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('RevCodeSearch', RevCodeSearch);

    RevCodeSearch.$inject = ['$resource'];

    function RevCodeSearch($resource) {
        var resourceUrl =  'api/_search/rev-codes';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true, ignoreLoadingBar: true}
        });
    }
})();
